"use strict";
import '/src/css/style.scss';

import InfiniteScroll from 'infinite-scroll';
import Masonry from 'masonry-layout';

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR");
  });
}

/* -------------------------------------------------------------- Check JS enabled  */

 function removeNoJs() {
  document.documentElement.className = document.documentElement.className.replace(/\bno-js\b/g, '') + ' js ';
}

/* -------------------------------------------------------------- Mobile menu */

function mobileMenu() {

  var menuToggle = document.querySelector('.js-navigation__toggle');
  var html = document.getElementsByTagName('html')[0];

  var toggleMenu = function(e) {
    e.preventDefault();
    html.classList.toggle('has-navigation-open');
    menuToggle.setAttribute('aria-expanded', html.classList.contains('has-navigation-open'));
  }

  var openMenu = function(e) {
    e.preventDefault();
    html.classList.add('has-navigation-open');
    menuToggle.setAttribute('aria-expanded', 'true');
  }

  var closeMenu = function(e) {
    e.preventDefault();
    html.classList.remove('has-navigation-open');
    menuToggle.setAttribute('aria-expanded', 'false');
  }

  menuToggle.addEventListener('click', toggleMenu);

  document.onkeydown = function(evt) {
    evt = evt || window.event;
    var isEscape = false;
    if ("key" in evt) {
      isEscape = (evt.key === "Escape" || evt.key === "Esc");
    } else {
      isEscape = (evt.keyCode === 27);
    }
    if (isEscape) {
      html.classList.remove('has-navigation-open');
    }
  };

}

/* -------------------------------------------------------------- Masonry fallback */

let masonryInstance = null;

function supportsGridLanes() {
  return (
    typeof CSS !== 'undefined' &&
    typeof CSS.supports === 'function' &&
    CSS.supports('display', 'grid-lanes')
  );
}

function initMasonryFallback(container) {
  if (supportsGridLanes()) return null;

  var grid = container.querySelector('.l-grid__container');
  if (!grid) return null;

  grid.classList.add('is-masonry');

  return new Masonry(grid, {
    itemSelector: '.c-entry',
    percentPosition: true,
    gutter: '.l-grid__gutter-sizer'
  });
}

/* ---------------------------------------------------------- Infinite Scroll */

function infinite() {
  "use strict";

  if (document.querySelector('.js-loadmore')) {
    var button = document.querySelector('.js-loadmore');
    var buttonLabel = button.childNodes[0].nodeValue;

    var elem = document.querySelector('.js-entries');
    var infScroll = new InfiniteScroll(elem, {
      path: '.js-loadmore',
      append: '.c-entry',
      //history: 'replace',
      history: 'push',
      button: '.js-loadmore',
      scrollThreshold: false
    });

    infScroll.on('request', function() {
      console.log('loading');
      button.innerHTML = 'Loading…';
    })

    infScroll.on('load', function() {
      console.log('loaded');
      button.innerHTML = buttonLabel;
    })

    infScroll.on('append', function(response, path, items) {
      if (masonryInstance) masonryInstance.appended(items);
    });
  }
}

/* ---------------------------------------------------------- Custom file input */

/*
	By Osvaldas Valutis, www.osvaldas.info
	Available for use under the MIT License
*/

'use strict';

;( function ( document, window, index )
{
	var inputs = document.querySelectorAll( '.custom-file-input' );
	Array.prototype.forEach.call( inputs, function( input )
	{
		var label	 = input.nextElementSibling,
			labelVal = label.innerHTML;

		input.addEventListener( 'change', function( e )
		{
			var fileName = '';
			if( this.files && this.files.length > 1 )
				fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
			else
				fileName = e.target.value.split( '\\' ).pop();

			if( fileName )
				label.querySelector( 'span' ).innerHTML = fileName;
			else
				label.innerHTML = labelVal;
		});

		// Firefox bug fix
		input.addEventListener( 'focus', function(){ input.classList.add( 'has-focus' ); });
		input.addEventListener( 'blur', function(){ input.classList.remove( 'has-focus' ); });
	});
}( document, window, 0 ));

/*---------------------------------------------------------------------- Init */
document.addEventListener("DOMContentLoaded", function() {
  removeNoJs();
  mobileMenu();
  masonryInstance = initMasonryFallback(document);
  infinite();
});